import { useMemo } from 'react';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import CtaBand from '@/components/feature/CtaBand';
import FaqAccordion from '@/components/feature/FaqAccordion';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { faqs } from '@/mocks/faqs';

export default function Faq() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://readdy.ai/' },
          { '@type': 'ListItem', position: 2, name: '常见问题' },
        ],
      },
    ],
    [],
  );

  useSeo({
    title: '常见问题｜缅北黑料 · 反诈内幕档案库',
    description:
      '关于缅北黑料内幕档案的常见问题：内容来源是否可靠、如何判断高薪出国招聘真伪、家人失联后怎么办、虚假投资为何能先小额提现等。',
    keywords: '缅北黑料常见问题,高薪招聘骗局,家属求助,虚假投资提现骗局',
    path: '/faq',
    jsonLd,
  });

  return (
    <SiteLayout>
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-content px-4 py-10 md:px-6 md:py-16">
          <Breadcrumbs items={[{ label: '常见问题' }]} />
          <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            常见问题解答
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里汇总了读者最常提出的疑问。如果你没有找到答案，可以带着具体情况通过联系表单提交，我们会补充进这一页。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
          <FaqAccordion items={faqs} />
        </div>
      </section>

      <CtaBand
        title="你的问题没有被回答？"
        desc="把具体情况写清楚发给我们，包括时间、地点与主要经过。我们会核实后补充进常见问题，或直接回复你。"
      />
    </SiteLayout>
  );
}